import angular from 'angular';

class LoginController {
  constructor($timeout) {
      this.name = 'login';
      this.loginText = 'Login';
      this.loading = false;
      this.error = false;
      this.$timeout = $timeout;
  }

  openLayout() {
    window.location.href = '/layout';
  }

  processLogin() {
      this.btnError = false;
      this.loading = true;
      this.$timeout(() => {
        this.loading = false;
        this.error = true;
        this.btnError = true;
        this.loginText = 'Login failed';    
      }, 3000);
  }
}
LoginController.$inject = ['$timeout'];

export default LoginController;



// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js